var _style, _g, _g2, _path, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163 294",
    width: 163,
    height: 294,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "char2-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #263238 } \n\t\t.s1 { fill: #455a64 } \n\t\t.s2 { fill: #ffffff;stroke: #263238 } \n\t\t.s3 { opacity: .2;fill: #000000 } \n\t\t.s4 { fill: #ff9a6c } \n\t\t.s5 { fill: #ffffff;stroke: #25292b } \n\t\t.s6 { fill: #000000 } \n\t\t.s7 { fill: #7b6bd9 } \n\t\t.s8 { fill: #e0e0e0 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    className: "s0",
    d: "m3.3 40.1c-1.2-0.7-2.2-1.8-2.8-3.1-0.5-1.3-0.6-2.7-0.3-4.1 0.3-1.4 1-2.6 2.1-3.5 1.1-1 2.4-1.5 3.8-1.6-1-1.1-1.7-2.4-2-3.8-0.3-1.5-0.1-3 0.5-4.3 0.6-1.4 1.6-2.5 2.8-3.3 1.3-0.7 2.8-1.1 4.2-1q-0.6-0.7-1.1-1.5-0.4-0.9-0.6-1.8-0.2-0.9-0.1-1.8 0.1-1 0.5-1.8 0.3-0.9 0.9-1.7 0.5-0.7 1.2-1.4 0.6-0.7 1.4-1.2 0.8-0.5 1.7-0.9c1.5-0.6 3.2-1 4.9-1 1.7 0 3.4 0.3 5 0.8 1.6 0.6 3.1 1.5 4.3 2.6 1.3 1.1 2.4 2.4 3.2 3.9l-3.3 56.8c-1.2 1.2-2.7 2-4.3 2.4-1.6 0.4-3.3 0.4-4.9 0-1.6-0.4-3-1.2-4.2-2.4-1.3-1.1-2.2-2.5-2.7-4.1q-0.7 0-1.5-0.2-0.7-0.1-1.5-0.2-0.7-0.2-1.5-0.4-0.7-0.3-1.4-0.6-0.7-0.3-1.4-0.7-0.6-0.5-1.1-1-0.5-0.6-0.8-1.3-0.4-0.7-0.6-1.4c-0.3-2 0.9-4.3 3-4.7-2.2-1.4-4.6-2.9-5.6-5.2-1.1-2.4-0.3-5.8 2.2-6.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    className: "s1",
    d: "m18.2 11.2c0.7-3 2.9-5.3 5.3-7.1q0.4-0.3 0.8-0.5 0.4-0.3 0.8-0.5 0.4-0.2 0.9-0.3 0.4-0.2 0.9-0.3 0.4-0.1 0.9 0 0.5 0 0.9 0.2 0.5 0.2 0.8 0.5 0.4 0.3 0.7 0.7l-0.2 2.1c0.2 3.3-2.5 6.1-3.7 9.2-0.6 1.3-1 2.9-2.4 3.5q-0.3 0.1-0.6 0.1-0.2 0-0.5 0-0.3 0-0.6 0-0.3-0.1-0.5-0.2c-2.9-1-4.2-4.5-3.5-7.4z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    className: "s0",
    d: "m17.7 26.5q-0.7-0.9-1-2.1-0.3-1.1-0.2-2.3 0.1-1.2 0.7-2.2 0.5-1.1 1.3-1.9c-1.2-1.6-0.7-3.9 0.6-5.4q0.6-0.5 1.1-1 0.6-0.4 1.3-0.8 0.6-0.4 1.3-0.7 0.6-0.3 1.3-0.6 0.5-1.6 1.6-3 1-1.4 2.5-2.2 1.5-0.9 3.3-1.2 1.7-0.2 3.4 0.2c2.4-3.4 7.4-3.8 11.4-2.5q0.3 0.1 0.7 0.3 0.4 0.1 0.7 0.2 0.4 0.1 0.8 0.1 0.4 0.1 0.7 0.1 0.3 0 0.6 0 0.3 0 0.6-0.1 0.2 0 0.5 0 0.3-0.1 0.6-0.1c4-0.4 8 2.5 9.5 6.3q0 0.3 0.1 0.5 0.1 0.2 0.2 0.4 0.1 0.3 0.2 0.5 0.2 0.2 0.3 0.4 0.2 0.2 0.4 0.5 0.3 0.2 0.5 0.4 0.3 0.2 0.5 0.4 0.3 0.2 0.5 0.4 0.6 0.4 1 1 0.4 0.5 0.7 1.1 0.3 0.7 0.5 1.3 0.2 0.7 0.2 1.4c0 1.6-0.5 3.2 0.1 4.7 0.3 0.7 0.9 1.3 1.1 2.1 0.7 2.1-1.8 4.3-1.4 6.5 0.1 0.5 0.3 0.9 0.4 1.4q0.1 0.3 0.1 0.7 0 0.3 0 0.7-0.1 0.3-0.2 0.7-0.1 0.3-0.2 0.6-0.2 0.3-0.3 0.5-0.2 0.2-0.3 0.5-0.1 0.2-0.2 0.5-0.1 0.2-0.2 0.5 0 0.2 0 0.4 0.1 0.2 0.1 0.4 0 0.2 0.1 0.5 0 0.2 0.1 0.4c0.2 1.3-2.8 6.4-4 7.1l-34.7-0.8q-1-0.2-1.9-0.7-0.8-0.6-1.5-1.3-0.6-0.8-1-1.7-0.4-1-0.5-2 0-0.1 0-0.3 0-0.2 0-0.3-0.1-0.2-0.1-0.3-0.1-0.2-0.2-0.3-0.1-0.1-0.2-0.2-0.1-0.1-0.2-0.2-0.1-0.1-0.3-0.2-0.1 0-0.2-0.1c-2.2-1.2-2.4-4.3-2.1-6.8q0-0.1 0.1-0.3 0-0.1 0-0.2 0-0.2 0-0.3 0-0.1-0.1-0.3 0-0.1-0.1-0.3-0.1-0.2-0.2-0.4-0.1-0.1-0.2-0.3-0.1-0.1-0.2-0.3z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_28",
    className: "s2",
    d: "m28.8 71.2l-0.7-24.6c-1.2 0.3-7.8 0.6-7.5-6.5 0.3-5.7 4.4-5.8 6.7-5.3q0.1 0 0.1 0 0.1 0.1 0.2 0.1 0 0 0.1 0.1 0 0 0.1 0.1l-0.2-8.2q0.1-2.5 0.8-4.9 0.8-2.4 2.1-4.4 1.4-2.1 3.3-3.8 1.8-1.6 4.1-2.8 1-0.4 2.1-0.7 1.1-0.4 2.3-0.6 1.1-0.3 2.2-0.4 1.2-0.1 2.3-0.1 1.1-0.1 2.2 0 1 0.1 2 0.3 1.1 0.3 2.1 0.7 1 0.4 1.9 0.9c1.9 0.5 8.7 7.1 8.8 14.1 0.2 7.7 0.1 17.1-1 22.8-2.3 11.4-11.3 12.6-11.3 12.6v9.1l0.8 7.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    className: "s0",
    d: "m59.6 35.1q0 0.3-0.1 0.6-0.1 0.3-0.3 0.5-0.2 0.2-0.5 0.3-0.3 0.1-0.6 0.1-0.3 0-0.5-0.1-0.3-0.1-0.5-0.3-0.2-0.2-0.3-0.5-0.2-0.2-0.2-0.5 0-0.3 0.2-0.6 0.1-0.2 0.3-0.4 0.2-0.2 0.5-0.4 0.2-0.1 0.5-0.1 0.3 0 0.6 0.1 0.3 0.1 0.5 0.3 0.2 0.2 0.3 0.5 0.1 0.3 0.1 0.5z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    className: "s0",
    d: "m61.1 29.5c-0.2 0.2-1.3-0.7-2.9-0.8-1.6-0.1-2.8 0.7-3 0.5-0.1-0.1 0.1-0.4 0.6-0.8q0.3-0.1 0.6-0.3 0.3-0.1 0.6-0.2 0.3 0 0.6-0.1 0.3 0 0.6 0 0.3 0 0.6 0.1 0.4 0 0.6 0.1 0.3 0.2 0.6 0.3 0.3 0.2 0.5 0.3c0.5 0.4 0.6 0.8 0.6 0.9z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    className: "s0",
    d: "m51.2 41.7q0.3-0.1 0.6-0.2 0.3 0 0.7-0.1 0.3 0 0.6-0.1 0.4 0 0.7 0c0.4 0 0.8-0.1 0.9-0.4q0-0.1 0-0.3 0-0.1 0-0.3-0.1-0.1-0.1-0.3-0.1-0.1-0.2-0.3-0.5-1.5-1-3.1c-1.5-4.5-2.6-8.2-2.4-8.2 0.2-0.1 1.5 3.5 3 8q0.6 1.6 1.1 3.1 0 0.2 0.1 0.4 0 0.2 0.1 0.4 0 0.2 0 0.4 0 0.2-0.1 0.4 0 0.1-0.1 0.2-0.1 0.1-0.2 0.2-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0.1-0.1 0-0.2 0-0.1 0.1-0.1 0.1-0.1 0-0.2 0-0.1 0-0.2 0-0.3 0-0.7 0-0.3 0-0.6 0-0.3 0-0.7 0-0.3-0.1-0.6-0.1z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    className: "s3",
    d: "m51.5 60.6q-2-0.1-4-0.4-2.1-0.4-4-1-2-0.6-3.8-1.4-1.9-0.9-3.6-2c-1.1-0.7 3.8 8.5 15.5 7.8z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6602",
    className: "s0",
    d: "m60.6 23.5c-0.2 0.4-1.5 0.1-2.9 0.1-1.4 0-2.6 0.4-2.9 0-0.2-0.1 0-0.5 0.5-0.9q0.5-0.3 1.1-0.5 0.6-0.2 1.3-0.2 0.6 0 1.2 0.1 0.6 0.2 1.2 0.5c0.5 0.3 0.7 0.7 0.5 0.9z"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3818"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    className: "s0",
    d: "m43.2 35.1q0 0.3 0.1 0.5 0.1 0.3 0.3 0.5 0.2 0.2 0.4 0.3 0.3 0.2 0.6 0.2 0.3 0 0.6-0.1 0.2-0.1 0.5-0.3 0.2-0.2 0.3-0.4 0.1-0.3 0.1-0.6 0-0.2-0.1-0.5-0.1-0.3-0.3-0.5-0.2-0.2-0.4-0.3-0.3-0.1-0.6-0.2-0.3 0-0.5 0.1-0.3 0.1-0.5 0.3-0.3 0.2-0.4 0.4-0.1 0.3-0.1 0.6z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    className: "s0",
    d: "m39.1 29.2c0.2 0.2 1.3-0.6 2.9-0.6 1.6 0 2.8 0.8 3 0.6 0.1-0.1-0.1-0.4-0.6-0.8q-0.3-0.2-0.6-0.3-0.3-0.1-0.6-0.2-0.3-0.1-0.6-0.2-0.3 0-0.6 0-0.3 0-0.6 0-0.3 0.1-0.6 0.2-0.3 0.1-0.6 0.2-0.3 0.1-0.5 0.3c-0.5 0.4-0.7 0.7-0.6 0.8z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6605",
    className: "s0",
    d: "m38.9 23.9c0.3 0.3 1.5 0 3-0.1 1.5 0 2.8 0.3 3.1-0.1 0.1-0.2-0.1-0.5-0.7-0.9q-0.5-0.3-1.2-0.4-0.6-0.2-1.2-0.2-0.7 0-1.3 0.2-0.6 0.2-1.2 0.6c-0.5 0.3-0.7 0.7-0.5 0.9z"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    className: "s4",
    d: "m26.3 43.5c-0.1 0-0.2 0.1-0.4 0.2q-0.1 0.1-0.3 0.1-0.1 0-0.2 0-0.2 0-0.3 0-0.1-0.1-0.2-0.1c-0.9-0.4-1.5-1.7-1.5-3.1q0-0.3 0.1-0.5 0-0.3 0.1-0.5 0-0.3 0.1-0.5 0.1-0.3 0.2-0.5 0.1-0.2 0.2-0.3 0.1-0.2 0.2-0.3 0.2-0.1 0.3-0.2 0.2-0.1 0.4-0.2 0.1 0 0.2 0 0.2 0 0.3 0.1 0.1 0 0.2 0.1 0 0.1 0.1 0.2c0.1 0.3 0 0.4 0.1 0.4 0 0.1 0.1-0.1 0.1-0.4q0-0.1 0-0.2-0.1 0-0.1-0.1 0-0.1-0.1-0.1 0-0.1-0.1-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.1-0.1-0.1 0-0.2-0.1-0.1 0-0.2 0-0.3 0.1-0.5 0.2-0.3 0.1-0.4 0.2-0.2 0.2-0.4 0.4-0.1 0.2-0.2 0.4-0.2 0.2-0.3 0.5-0.1 0.3-0.2 0.5 0 0.3-0.1 0.6 0 0.3 0 0.6c-0.1 1.5 0.7 3.1 1.8 3.4q0.2 0.1 0.3 0.1 0.2 0 0.4 0 0.1 0 0.3-0.1 0.2 0 0.3-0.1c0.2-0.2 0.3-0.4 0.3-0.4z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6608",
    className: "s0",
    d: "m65.6 25.3q-0.5-0.3-1-0.7-0.4-0.5-0.8-1.1-0.3-0.6-0.4-1.2-0.1-0.6-0.1-1.3c-1.1 0.3-2.1-1.1-2.7-2-0.6-1-1.3-1.5-1.2-2.6q0 0 0-0.1 0-0.1 0-0.2 0-0.1 0-0.1 0-0.1-0.1-0.2c-0.1-0.3-0.5-0.4-0.8-0.5q-0.6-0.3-1.2-0.6-0.5-0.4-1-0.9-0.4-0.5-0.7-1.1-0.3-0.6-0.4-1.2-0.7 0.2-1.4 0.4-0.6 0.2-1.3 0.2-0.7 0.1-1.4 0.1-0.7 0-1.4-0.1c-0.4 0.6-1 1.1-1.7 1.4-0.6 0.3-1.4 0.4-2.1 0.3-0.7 0-1.4-0.3-2-0.7-0.6-0.4-1.1-0.9-1.4-1.6q-0.3 0.4-0.5 0.7-0.3 0.3-0.7 0.5-0.3 0.2-0.7 0.4-0.4 0.2-0.8 0.2-0.4 0.1-0.8 0.1-0.4 0.1-0.8 0.1-0.5 0-0.9-0.1-0.4 0-0.8 0 0.1 0.8 0 1.6-0.2 0.8-0.6 1.5-0.5 0.6-1.1 1.1-0.7 0.5-1.5 0.8c-0.3 0-0.6 0.1-0.7 0.4q-0.1 0.1-0.1 0.2 0 0.1 0 0.2 0 0.1 0.1 0.2 0 0.1 0.1 0.2 0.2 0.7 0.1 1.5-0.1 0.7-0.5 1.3-0.3 0.6-0.9 1.1-0.6 0.4-1.3 0.6 0.4 0.4 0.6 1 0.2 0.5 0.2 1.1-0.1 0.6-0.4 1.2-0.3 0.5-0.8 0.8c-0.3 0.2-0.7 0.4-0.7 0.7q0 0 0.1 0.1 0 0 0 0.1 0 0 0 0.1 0.1 0 0.1 0 0.2 0.3 0.4 0.6 0.2 0.3 0.4 0.7 0.1 0.3 0.2 0.7 0.1 0.3 0.1 0.7 0.1 0.3 0 0.7-0.1 0.3-0.4 0.6-0.2 0.3-0.5 0.5-0.3 0.2-0.7 0.2 0.2 0.2 0.4 0.4 0.1 0.2 0.2 0.4 0.2 0.2 0.2 0.5 0.1 0.2 0.1 0.5c0 0.7-0.7 1.3-1.3 1.1-0.3-0.2-4.2-1.1-4.4-1.3-2.1-3.1 0.8-6.4 1.2-10.1q0.2-1.4 0.5-2.8 0.3-1.3 0.8-2.7 0.5-1.3 1.1-2.5 0.7-1.3 1.5-2.5 0.3-0.5 0.6-1 0.3-0.5 0.7-0.9 0.4-0.5 0.8-0.9 0.4-0.4 0.8-0.9 0.5-0.4 1.1-0.8 0.5-0.4 1.1-0.8 0.5-0.4 1.1-0.7 0.6-0.4 1.2-0.7 0.7-0.4 1.5-0.9 0.8-0.4 1.6-0.7 0.8-0.4 1.7-0.6 0.8-0.3 1.7-0.5c4.3-0.9 8.6 0.9 12.6 2.8q0.5 0.3 1.1 0.6 0.5 0.3 1 0.6 0.6 0.4 1.1 0.8 0.5 0.3 1 0.7 0.5 0.6 1 1.1 0.5 0.6 0.9 1.2 0.4 0.6 0.8 1.3 0.4 0.6 0.7 1.3 0.5 0.9 0.9 1.9 0.5 1 0.8 2 0.3 1.1 0.5 2.1 0.2 1.1 0.3 2.1"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6609",
    className: "s1",
    d: "m67.3 22.6q0-0.1-0.1-0.2 0-0.1-0.1-0.2 0-0.1-0.1-0.2 0-0.1-0.1-0.2c-0.1-0.3-0.4-0.6-0.6-1q-0.1-0.2-0.1-0.3-0.1-0.2-0.1-0.4-0.1-0.2-0.1-0.4-0.1-0.2-0.1-0.4 0-0.2 0-0.5 0-0.2 0.1-0.5 0-0.2 0-0.4 0-0.3 0.1-0.5 0-0.3 0-0.6 0-0.3 0-0.6 0-0.3 0-0.6 0-0.3 0-0.6-0.1-0.3-0.2-0.6 0-0.4-0.2-0.7-0.1-0.3-0.2-0.6-0.2-0.3-0.4-0.6-0.1-0.1-0.2-0.3-0.1-0.1-0.2-0.3-0.1-0.1-0.2-0.3-0.2-0.1-0.3-0.2-0.1-0.2-0.3-0.3-0.1-0.1-0.3-0.2-0.1-0.2-0.3-0.3-0.1-0.1-0.3-0.2-0.2-0.1-0.3-0.2-0.2-0.2-0.3-0.3-0.2-0.1-0.3-0.3-0.1-0.1-0.3-0.3-0.1-0.2-0.2-0.3-0.1-0.2-0.2-0.4-0.1-0.2-0.1-0.4-0.1-0.2-0.2-0.4-0.3-0.9-0.8-1.7-0.4-0.8-1.1-1.5-0.6-0.7-1.3-1.3-0.7-0.6-1.5-1.1-0.3-0.1-0.5-0.2-0.2-0.1-0.5-0.2-0.2-0.1-0.4-0.2-0.3-0.1-0.5-0.1-0.3-0.1-0.5-0.2-0.3 0-0.5-0.1-0.3 0-0.6 0-0.2-0.1-0.5-0.1-0.1 0-0.3 0-0.1 0-0.2 0-0.2 0.1-0.3 0.1-0.1 0-0.3 0-0.5 0.1-1 0.1-0.3 0.1-0.5 0.1-0.3 0-0.6 0-0.2 0-0.5 0-0.3-0.1-0.5-0.1c-0.7-0.2-1.4-0.5-2.1-0.7q-0.6-0.2-1.2-0.3-0.5-0.1-1.1-0.2-0.6-0.1-1.1-0.1-0.6 0-1.2 0-0.3 0-0.6 0.1-0.3 0-0.6 0-0.3 0.1-0.5 0.1-0.3 0.1-0.6 0.1-0.6 0.2-1.2 0.4-0.5 0.2-1.1 0.6-0.5 0.3-0.9 0.7-0.5 0.4-0.9 0.8l-0.3 0.4 0.1-0.1q-1.7-0.4-3.4-0.1-1.8 0.3-3.3 1.2-1.5 0.8-2.6 2.2-1.1 1.4-1.6 3.1l0.1-0.1q-0.4 0.2-0.7 0.3-0.4 0.2-0.8 0.3-0.3 0.2-0.7 0.4-0.3 0.2-0.6 0.4-0.4 0.1-0.7 0.4-0.3 0.2-0.6 0.4-0.3 0.3-0.6 0.5-0.2 0.3-0.5 0.6-0.2 0.3-0.4 0.6-0.2 0.3-0.3 0.6-0.2 0.4-0.3 0.7-0.1 0.4-0.1 0.8-0.1 0.3-0.1 0.7 0.1 0.3 0.1 0.7 0.1 0.3 0.3 0.6 0.1 0.4 0.3 0.6v-0.1q-0.4 0.4-0.7 0.9-0.3 0.4-0.6 0.9-0.2 0.5-0.4 1.1-0.2 0.5-0.2 1.1-0.1 0.5-0.1 1 0 0.5 0.1 1 0.1 0.5 0.2 1 0.2 0.5 0.4 0.9 0.1 0.1 0.2 0.2 0 0.1 0.1 0.2 0 0.1 0.1 0.2 0.1 0.1 0.1 0.2 0.1 0.1 0.2 0.2 0 0.1 0.1 0.2 0.1 0.1 0.1 0.2 0.1 0.1 0.2 0.1 0 0.1 0.1 0.2 0 0.1 0 0.2 0.1 0.1 0.1 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2-0.1 0.4-0.1 0.8 0 0.4 0 0.7-0.1 0.4 0 0.8 0 0.4 0 0.7 0.1 0.3 0.1 0.6 0.1 0.3 0.2 0.6 0 0.3 0.2 0.6 0.1 0.3 0.2 0.5 0.1 0.2 0.2 0.4 0.2 0.2 0.3 0.4 0.2 0.1 0.3 0.3 0.2 0.1 0.4 0.3c0.4 0.2 0.8 0.4 0.9 0.5q0.1 0 0.1 0.1 0.1 0 0.1 0 0 0.1 0.1 0.1 0 0 0 0.1 0-0.1 0-0.1-0.1-0.1-0.1-0.1 0 0-0.1-0.1 0 0 0 0c-0.2-0.2-0.6-0.3-1-0.6q-0.1-0.1-0.3-0.3-0.2-0.1-0.3-0.3-0.2-0.2-0.3-0.3-0.1-0.2-0.2-0.4-0.1-0.3-0.3-0.6-0.1-0.2-0.1-0.5-0.1-0.3-0.2-0.6 0-0.3-0.1-0.6 0-0.3 0-0.7 0-0.4 0-0.8 0-0.3 0-0.7 0-0.4 0.1-0.7 0-0.1 0-0.2 0-0.2 0-0.3 0-0.1 0-0.2 0.1-0.1 0.1-0.2-0.1-0.1-0.1-0.2 0-0.1 0-0.2-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.1-0.1-0.2-0.2 0-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.1-0.1-0.2-0.2 0-0.1-0.1-0.1-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.2-0.5-0.4-1-0.1-0.4-0.2-0.9-0.1-0.5-0.1-1 0-0.5 0-1 0.1-0.5 0.3-1.1 0.1-0.5 0.4-1 0.2-0.5 0.6-0.9 0.3-0.5 0.7-0.8v-0.1-0.1q-0.2-0.2-0.3-0.6-0.2-0.3-0.3-0.6 0-0.3 0-0.6-0.1-0.4 0-0.7 0-0.4 0.1-0.7 0.1-0.3 0.3-0.7 0.1-0.3 0.3-0.6 0.2-0.3 0.4-0.6 0.2-0.3 0.5-0.5 0.3-0.3 0.5-0.5 0.3-0.3 0.6-0.5 0.3-0.2 0.7-0.4 0.3-0.1 0.7-0.3 0.3-0.2 0.7-0.4 0.3-0.1 0.7-0.3 0.3-0.1 0.7-0.3v-0.1q0.5-1.6 1.6-2.9 1-1.4 2.5-2.2 1.5-0.9 3.2-1.2 1.7-0.2 3.3 0.2h0.1l0.1-0.1 0.3-0.3q0.4-0.5 0.8-0.9 0.5-0.3 1-0.6 0.5-0.3 1-0.6 0.6-0.2 1.1-0.3 0.3-0.1 0.6-0.1 0.3-0.1 0.6-0.1 0.3-0.1 0.6-0.1 0.2 0 0.5-0.1 0.3 0 0.6 0 0.3 0 0.6 0 0.3 0.1 0.5 0.1 0.3 0 0.6 0 0.3 0.1 0.6 0.1 0.2 0.1 0.5 0.1 0.3 0.1 0.6 0.2 0.2 0 0.5 0.1c0.7 0.2 1.4 0.5 2.1 0.7q0.2 0 0.3 0 0.1 0.1 0.3 0.1 0.1 0 0.2 0 0.2 0 0.3 0 0.2 0 0.3 0 0.1 0 0.3 0 0.1 0 0.3 0 0.1 0 0.2-0.1 0.6 0 1.1-0.1 0.1 0 0.2 0 0.2 0 0.3 0 0.1 0 0.3 0 0.1 0 0.2 0 0.3 0 0.5 0 0.3 0 0.5 0 0.3 0.1 0.5 0.1 0.3 0.1 0.5 0.2 0.3 0 0.5 0.1 0.2 0.1 0.5 0.2 0.2 0.1 0.4 0.2 0.2 0.1 0.5 0.2 0.8 0.5 1.5 1 0.7 0.6 1.3 1.3 0.6 0.7 1.1 1.5 0.5 0.8 0.8 1.7 0 0.2 0.1 0.4 0.1 0.2 0.2 0.4 0.1 0.2 0.2 0.4 0.1 0.1 0.2 0.3 0.1 0.2 0.3 0.3 0.1 0.2 0.3 0.3 0.1 0.2 0.3 0.3 0.1 0.1 0.3 0.2 0.2 0.1 0.3 0.2 0.2 0.2 0.3 0.3 0.2 0.1 0.3 0.2 0.2 0.1 0.3 0.3 0.1 0.1 0.3 0.2 0.1 0.2 0.2 0.3 0.1 0.2 0.2 0.3 0.1 0.1 0.2 0.3 0.2 0.3 0.3 0.6 0.2 0.3 0.3 0.6 0.1 0.3 0.2 0.6 0.1 0.3 0.2 0.7 0 0.2 0 0.5 0 0.3 0 0.6 0 0.3 0 0.6 0 0.3-0.1 0.6 0 0.2 0 0.4 0 0.3 0 0.5-0.1 0.3-0.1 0.5 0 0.3 0.1 0.5 0 0.2 0 0.4 0 0.2 0.1 0.4 0 0.2 0.1 0.4 0.1 0.2 0.2 0.3c0.2 0.4 0.4 0.7 0.6 1q0 0.1 0.1 0.2 0 0 0.1 0.1 0 0.1 0 0.2 0.1 0 0.1 0.1 0.1 0.3 0.1 0.2z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6610",
    className: "s1",
    d: "m38.7 1.7c0 0 0.2-0.1 0.6-0.3q0.2-0.1 0.4-0.2 0.2-0.1 0.4-0.1 0.2-0.1 0.5-0.1 0.2 0 0.4-0.1 0.3 0 0.7 0 0.3 0.1 0.6 0.1 0.4 0.1 0.7 0.2 0.3 0.1 0.6 0.2 0.4 0.2 0.7 0.4 0.3 0.3 0.6 0.6 0.3 0.2 0.5 0.6 0.3 0.3 0.5 0.6 0 0.1 0.1 0.3 0 0.1 0.1 0.2 0 0.1 0.1 0.2 0 0.1 0 0.2 0.1 0.1 0.1 0.3 0 0.1 0 0.2 0 0.1-0.1 0.2 0 0.1-0.1 0.2l-0.2 0.2h0.4q0.3-0.1 0.6-0.1 0.3 0 0.6 0 0.3 0.1 0.6 0.2 0.3 0.1 0.6 0.2 0.2 0.2 0.4 0.3 0.2 0.2 0.4 0.4 0.1 0.2 0.3 0.4 0.1 0.2 0.2 0.4 0.1 0.2 0.1 0.4 0.1 0.1 0.1 0.3 0 0.1 0 0.3 0 0.2 0 0.3c0 0.4 0 0.5 0 0.5q0.1 0 0.1-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0.1-0.4 0-0.8-0.1-0.5-0.3-0.8-0.2-0.4-0.5-0.8-0.3-0.3-0.7-0.5-0.3-0.2-0.6-0.3-0.3-0.2-0.6-0.2-0.4-0.1-0.7-0.1-0.4 0.1-0.7 0.1l0.1 0.2q0.1-0.1 0.1-0.2 0.1-0.2 0.1-0.3 0-0.1 0-0.2 0-0.2 0-0.3-0.1-0.1-0.1-0.3 0-0.1-0.1-0.2 0-0.1-0.1-0.2-0.1-0.2-0.1-0.3-0.2-0.3-0.5-0.7-0.2-0.3-0.5-0.6-0.3-0.3-0.7-0.6-0.3-0.2-0.7-0.4-0.3-0.1-0.7-0.2-0.3-0.1-0.6-0.2-0.4 0-0.7 0-0.4-0.1-0.7 0-0.2 0-0.5 0-0.2 0.1-0.4 0.2-0.2 0-0.5 0.1-0.2 0.1-0.4 0.2 0 0-0.1 0.1 0 0-0.1 0-0.1 0.1-0.1 0.1-0.1 0-0.1 0.1-0.1 0.1-0.1 0.1z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6611",
    className: "s1",
    d: "m25.5 10.2q0 0.1 0 0.1 0.1 0 0.1 0.1 0 0 0.1 0 0 0.1 0 0.1 0.1 0.1 0.2 0.2 0.2 0.1 0.3 0.2 0.1 0 0.2 0.1 0.1 0.1 0.2 0.2 0.2 0.1 0.4 0.2 0.2 0 0.4 0.1 0.2 0.1 0.4 0.1 0.2 0.1 0.4 0.1 0.2 0 0.5 0 0.3 0 0.5-0.1 0.3-0.1 0.5-0.2 0.2-0.1 0.5-0.2l-0.2-0.1 0.2 0.4q0.1 0.1 0.3 0.3 0.2 0.2 0.4 0.4 0.2 0.2 0.5 0.4 0.2 0.1 0.5 0.3 0.2 0.1 0.5 0.2 0.2 0.1 0.5 0.1 0.2 0.1 0.4 0.1 0.3 0.1 0.5 0.1 0.2 0 0.5 0 0.1 0 0.3 0 0.2 0 0.3-0.1 0.2 0 0.3 0 0.2-0.1 0.3-0.1 0.1-0.1 0.1-0.1 0.1 0 0.1 0 0.1 0 0.2-0.1 0 0 0.1 0-0.3 0-0.5 0.1-0.2 0-0.4 0-0.2 0.1-0.4 0.1-0.2 0-0.4 0-0.3 0-0.5 0-0.2 0-0.4-0.1-0.3 0-0.5-0.1-0.2 0-0.4-0.1-0.3-0.1-0.5-0.2-0.3-0.2-0.5-0.3-0.2-0.2-0.5-0.4-0.2-0.2-0.4-0.4-0.1-0.1-0.2-0.3-0.1-0.1-0.2-0.3l-0.1-0.1-0.1 0.1q-0.2 0.1-0.4 0.2-0.2 0.1-0.4 0.2-0.3 0.1-0.5 0.1-0.3 0-0.5 0-0.2 0-0.4-0.1-0.2 0-0.4-0.1-0.2 0-0.4-0.1-0.1-0.1-0.3-0.2c-0.8-0.4-1.2-0.8-1.2-0.8z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6612",
    className: "s1",
    d: "m21 17.4q0 0 0 0.1 0 0.1 0.1 0.1 0 0.1 0 0.1 0 0 0 0.1 0.1 0 0.1 0.1 0.1 0.1 0.2 0.3 0.2 0.1 0.3 0.2 0.2 0.2 0.4 0.2 0.1 0.1 0.3 0.2 0.3 0 0.6 0.1 0.3 0 0.6 0 0.3-0.1 0.6-0.1 0.2-0.1 0.5-0.2 0.2 0 0.3-0.1 0.2 0 0.3-0.1 0.2 0 0.4-0.1 0.1-0.1 0.3-0.1 0.2-0.1 0.3-0.2 0.2-0.1 0.3-0.2 0.2-0.1 0.3-0.3 0.1-0.1 0.2-0.3l0.1-0.1h-0.2q0.2 0.3 0.5 0.5 0.3 0.2 0.6 0.4 0.2 0.2 0.5 0.3 0.4 0.2 0.7 0.3 0.2 0.2 0.5 0.2 0.3 0.1 0.5 0.1 0.3 0.1 0.6 0.1 0.3 0 0.6-0.1 0.2 0 0.3 0 0.2-0.1 0.4-0.1 0.2-0.1 0.4-0.2 0.1-0.1 0.3-0.2 0 0 0-0.1 0.1 0 0.1 0 0.1-0.1 0.1-0.1 0-0.1 0.1-0.1 0.1-0.1 0-0.1c0 0-0.1 0.1-0.4 0.3q-0.1 0.1-0.3 0.2-0.2 0.1-0.3 0.1-0.2 0.1-0.4 0.1-0.2 0.1-0.3 0.1-0.3 0-0.6 0-0.3 0-0.5 0-0.3-0.1-0.5-0.2-0.3 0-0.6-0.2-0.3-0.1-0.5-0.3-0.3-0.1-0.6-0.3-0.3-0.2-0.6-0.4-0.2-0.2-0.5-0.4l-0.1-0.1-0.1 0.1v0.1q-0.1 0.2-0.2 0.3-0.1 0.1-0.2 0.2-0.2 0.1-0.3 0.2-0.2 0.1-0.3 0.2c-0.4 0.1-0.9 0.3-1.3 0.4q-0.2 0.1-0.5 0.2-0.3 0-0.5 0.1-0.3 0-0.6 0-0.2 0-0.5-0.1-0.2 0-0.4-0.1-0.1-0.1-0.3-0.2-0.1-0.1-0.3-0.2-0.1-0.1-0.2-0.3-0.1 0-0.1-0.1 0 0-0.1-0.1 0-0.1 0-0.1-0.1-0.1-0.1-0.1z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6613",
    className: "s3",
    d: "m45.8 45.2q0-0.1 0.1-0.2 0-0.2 0.1-0.3 0-0.1 0.1-0.2 0-0.1 0.1-0.3 0.1-0.1 0.2-0.2 0.1-0.1 0.2-0.1 0.1-0.1 0.2-0.1 0.1-0.1 0.3-0.1 0.1 0.1 0.2 0.1 0.1 0 0.2 0 0 0.1 0.1 0.1 0.1 0.1 0.2 0.1 1.4 0.9 2.9 1.8l0.2 0.7q-0.2 0.3-0.5 0.6-0.2 0.3-0.5 0.6-0.3 0.3-0.6 0.5-0.3 0.3-0.6 0.5-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0.1-0.2 0-0.3 0-0.1 0-0.3 0-0.1-0.1-0.3-0.1-0.1-0.1-0.2-0.2-0.2-0.1-0.3-0.2-0.4-0.2-0.7-0.6-0.3-0.4-0.4-0.8-0.1-0.5-0.1-1 0.1-0.4 0.3-0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6614",
    className: "s0",
    d: "m47.9 49.2q-0.2-0.1-0.3-0.2-0.2-0.1-0.4-0.2-0.2-0.1-0.3-0.2-0.2-0.2-0.4-0.3-0.1-0.2-0.2-0.3-0.2-0.2-0.3-0.4-0.1-0.2-0.2-0.4 0-0.2-0.1-0.4 0-0.3 0-0.6 0-0.2 0-0.5 0-0.3 0.1-0.5 0.1-0.3 0.2-0.5 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.2 0 0 0.1-0.1 0 0 0.1-0.1 0 0 0-0.1 0.1 0 0.1-0.1 0.1 0 0.1-0.1 0.1 0 0.1 0 0.1-0.1 0.1-0.1 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0 0.1 0.1 0.1 0.1 0.1 0 0.1 0 0.1 0.1 0.1 0.1 0.1 0 0.2 0.1 0.9 0.5 1.6 0.9 0.1 0.2 0.3 0.3 0.2 0.1 0.4 0.2 0.2 0.1 0.4 0.2 0.2 0.1 0.4 0.1-0.2-0.1-0.3-0.2-0.2-0.2-0.4-0.3-0.1-0.2-0.3-0.3-0.2-0.1-0.4-0.2-0.7-0.5-1.5-1-0.1-0.1-0.2-0.1 0-0.1-0.1-0.1-0.1 0-0.1-0.1-0.1 0-0.1 0-0.1-0.1-0.2-0.1-0.1 0-0.2 0-0.1 0-0.2 0-0.1 0.1-0.2 0.1 0 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.2-0.1 0-0.1 0.1-0.1 0-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.1-0.1 0.2-0.2 0.3-0.3 0.5 0 0.3-0.1 0.6 0 0.3 0 0.6 0 0.3 0.1 0.6 0 0.3 0.1 0.5 0.1 0.2 0.2 0.4 0.1 0.3 0.3 0.4 0.2 0.2 0.3 0.4 0.2 0.1 0.3 0.2 0.1 0.1 0.3 0.2 0.1 0.1 0.3 0.1 0.1 0.1 0.3 0.2c0.3 0.1 0.4 0.1 0.4 0z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4018"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6615",
    className: "s5",
    d: "m121.5 145.9l-3.9-6-6.3-3.1-0.3-0.2q-0.7-0.6-1.6-0.9-0.9-0.4-1.8-0.6-1-0.2-1.9-0.1-1 0-1.9 0.3c-2.6 0.6-6 1.5-9 2l-6.8-1.9v13.3l34.4-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6616",
    className: "s4",
    d: "m121.3 145.5q-0.2-0.2-0.3-0.4-0.2-0.1-0.4-0.3-0.2-0.2-0.4-0.3-0.1-0.2-0.3-0.3c-1-0.8-2.3-1.8-3.7-3l-1.4-1v-0.1h-0.1c-1.4-0.2-2.6-0.4-3.5-0.6q-0.2 0-0.4 0-0.1-0.1-0.3-0.1-0.2 0-0.4 0-0.1 0-0.3 0 0.1 0.1 0.3 0.1 0.2 0.1 0.4 0.1 0.1 0.1 0.3 0.1 0.2 0.1 0.3 0.1c0.9 0.2 2.1 0.5 3.5 0.7h-0.1l1.4 1.1c1.5 1.1 2.8 2.1 3.8 2.8q0.2 0.2 0.4 0.3 0.2 0.2 0.4 0.3 0.2 0.1 0.4 0.3 0.2 0.1 0.4 0.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6617",
    className: "s4",
    d: "m118.6 146.7q-0.6-0.5-1.2-0.9-0.6-0.3-1.2-0.7-0.6-0.4-1.2-0.7-0.7-0.4-1.3-0.7l-1.2-0.7h-0.1q-0.6 0-1.1-0.1-0.6 0-1.1 0-0.6 0-1.1 0-0.6 0-1.1 0 0.5 0.1 1.1 0.2 0.5 0.1 1.1 0.2 0.5 0 1 0.1 0.6 0 1.2 0h-0.1l1.2 0.7q0.6 0.3 1.2 0.7 0.7 0.3 1.3 0.7 0.6 0.3 1.3 0.6 0.7 0.3 1.3 0.6z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6618",
    className: "s1",
    d: "m161.6 108.4q-0.4-0.2-0.9-0.3-0.5-0.1-0.9 0-0.5 0.1-0.9 0.4-0.4 0.3-0.7 0.6l-27.7 37.4-43.9 0.5c-1.7 0.1-3.8 3.7-2.3 5.4l49.6-0.7 28.6-39.5q0.3-0.5 0.4-1 0.1-0.5 0-1.1-0.1-0.5-0.5-1-0.3-0.4-0.8-0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6619",
    className: "s0",
    d: "m161.6 108.4q0 0 0.1 0 0 0.1 0 0.1 0.1 0 0.1 0 0 0 0 0 0.1 0.1 0.2 0.1 0.1 0.1 0.1 0.2 0.1 0 0.2 0.1 0 0 0.1 0.1 0.2 0.3 0.4 0.6 0.1 0.4 0.2 0.7 0 0.4 0 0.8-0.1 0.3-0.2 0.6-0.1 0.3-0.3 0.5-0.1 0.2-0.3 0.4-0.1 0.3-0.3 0.5-0.1 0.2-0.3 0.4l-1.4 2-3.7 5.1-22.5 31.2v0.1h-0.1l-48.7 0.7h-0.9-0.1v-0.1q-0.2-0.2-0.3-0.4-0.1-0.2-0.2-0.4-0.1-0.2-0.1-0.5-0.1-0.2 0-0.4 0-0.3 0-0.5 0-0.2 0.1-0.4 0.1-0.2 0.1-0.5 0.1-0.2 0.2-0.4 0.1-0.2 0.2-0.4 0.2-0.2 0.3-0.3 0.1-0.2 0.3-0.4 0.1-0.2 0.3-0.3 0.1-0.2 0.3-0.3 0.2-0.2 0.4-0.3 0.3-0.1 0.5-0.1 0.2-0.1 0.4-0.1l6.8-0.1 13.1-0.1 23.9-0.3h-0.2l21.8-29.2 6.2-8.1q0.2-0.3 0.5-0.5 0.3-0.2 0.6-0.3 0.3-0.1 0.7-0.2 0.3 0 0.7 0.1 0.1 0 0.2 0 0.1 0.1 0.2 0.1 0.1 0 0.2 0.1 0.1 0 0.2 0.1-0.1 0-0.2-0.1-0.1 0-0.2-0.1-0.1 0-0.2 0-0.1 0-0.3-0.1-0.3 0-0.6 0-0.3 0.1-0.7 0.2-0.3 0.1-0.5 0.3-0.3 0.2-0.5 0.4l-6.1 8.3-21.6 29.3h-0.1-0.1l-23.9 0.4-13.1 0.2-6.7 0.1q-0.2 0-0.4 0-0.2 0.1-0.4 0.2-0.2 0-0.3 0.2-0.2 0.1-0.3 0.2-0.1 0.2-0.3 0.3-0.1 0.2-0.2 0.3-0.2 0.2-0.3 0.4-0.1 0.1-0.2 0.3-0.2 0.4-0.3 0.7-0.1 0.4-0.1 0.8 0 0.4 0.1 0.8 0.2 0.4 0.4 0.7l-0.2-0.1h0.9l48.7-0.6-0.2 0.1 22.6-31.1 3.7-5.1 1.5-2q0.2-0.2 0.3-0.4 0.2-0.2 0.3-0.4 0.2-0.2 0.3-0.5 0.1-0.2 0.3-0.4 0.1-0.3 0.2-0.7 0-0.3 0-0.7-0.1-0.3-0.2-0.6-0.1-0.4-0.4-0.6 0-0.1-0.1-0.2-0.1-0.1-0.2-0.2-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.2z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3936"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_27",
    fillRule: "evenodd",
    className: "s5",
    d: "m38.3 150.5l-22.1 0.1c0 0-4.1-2.7-1.5-8.2 1.5-3 2.5-7.6 1.9-10.7-0.7-3.2-2-21.9-2-26.9 0-5-0.7-21.8 0.2-26.3q0.3-1.3 0.8-2.6 0.4-1.3 1.1-2.5 0.7-1.2 1.5-2.3 0.8-1.1 1.8-2.1 0.6-0.5 1.3-1 0.6-0.5 1.3-0.9 0.7-0.5 1.4-0.9 0.7-0.4 1.5-0.8 1 0 2 0 1 0.1 2 0.2 1 0.1 2 0.2 1 0.2 2 0.4c2.5 0.4 4.5 0.8 4.6 0.8 1.5 0.5 11.1 3.6 11.1 3.6 7.7 11.2 15.9 21.3 19 29 5.5 13.3-1.2 21.6-1.2 21.6q-0.1 1-0.2 1.9-0.1 0.9-0.1 1.9 0 0.9 0.1 1.9 0 0.9 0.2 1.8l25 5.2-1 16.3c0 0-30.8 0.2-44.7 0.9q-0.9 0-1.7 0-0.8 0-1.6 0-0.8 0-1.5-0.1-0.8-0.1-1.6-0.2-0.8-0.2-1.6-0.3zm-0.2-83.5c-0.2 0-0.2-0.1 0 0q0 0 0 0z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3930"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6622",
    className: "s0",
    d: "m46.1 124.5c0.1 0.1-1 1.5-1.9 3.5-0.9 2-1.3 3.8-1.5 3.8q0.1-1.1 0.4-2 0.2-1 0.7-2 0.4-0.9 1-1.7 0.6-0.9 1.3-1.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3933",
    style: {
      opacity: 0.3
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6623",
    className: "s6",
    d: "m44.5 83c4.6 14 3.6 35.6 12.4 43.6l-10.9-2.2q0.1-1 0.2-1.9 0-1 0-1.9 0-1 0-1.9 0-1-0.1-2c-0.9-11-1-22.3-1.6-33.7z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6624",
    className: "s0",
    d: "m43.5 78q0.1 0.4 0.2 0.8 0.2 0.4 0.3 0.8 0.1 0.4 0.2 0.8 0 0.4 0.1 0.8 0.1 0.5 0.2 0.9 0.1 0.5 0.1 1 0.1 0.5 0.2 1 0 0.5 0.1 1c0.1 1.6 0.1 3.4 0.2 5.4 0.3 8.1 0.7 19.7 1.1 33.9l-0.1-0.2 46 9.5h0.2l-0.1 0.2c-0.3 5.2-0.6 10.7-1 16.3v0.2h-0.2l-5.6 0.1c-8 0.1-15.8 0.2-23.4 0.3q-5.6 0.2-11.1 0.3c-3.6 0.1-7.1 0.5-10.6-0.1q-0.6-0.1-1.3-0.2-0.6-0.1-1.2-0.3-0.7-0.1-1.3-0.3-0.6-0.2-1.2-0.5-0.6-0.2-1.2-0.5-0.5-0.2-1.1-0.5-0.5-0.3-1.1-0.7-0.5-0.3-1-0.7-1-0.7-1.9-1.5-0.9-0.8-1.7-1.6-0.9-0.9-1.6-1.8-0.8-0.9-1.5-1.9-1.3-1.9-2.5-3.8l-0.6-0.9q-0.3-0.5-0.5-1l-0.5-0.9q-0.2-0.5-0.4-1-0.4-1-0.7-2-0.3-1-0.6-2-0.2-0.9-0.4-1.9-0.2-1.1-0.4-2.1-0.3-1.7-0.5-3.5-0.2-1.7-0.4-3.5-0.1-1.7-0.3-3.5-0.1-1.7-0.1-3.5c-0.2-4.1-0.3-7.7-0.4-10.6-0.1-2.9-0.2-5.1-0.3-6.7q-0.1-1.1-0.1-1.7-0.1-0.6 0-0.6 0 0 0 0.6 0.1 0.6 0.2 1.7c0.1 1.6 0.2 3.8 0.3 6.7 0.2 2.9 0.3 6.5 0.5 10.6q0.1 1.8 0.2 3.5 0.2 1.8 0.3 3.5 0.2 1.8 0.4 3.5 0.3 1.7 0.5 3.5 0.2 1 0.4 2 0.2 1 0.5 2 0.2 0.9 0.5 1.9 0.3 1 0.7 1.9 0.2 0.5 0.4 1 0.2 0.5 0.5 1 0.2 0.4 0.5 0.9l0.6 0.9q1.2 1.9 2.5 3.8 0.7 0.9 1.5 1.8 0.7 1 1.6 1.8 0.8 0.8 1.7 1.6 0.9 0.8 1.8 1.5 0.5 0.4 1 0.7 0.6 0.3 1.1 0.6 0.5 0.3 1.1 0.6 0.6 0.2 1.1 0.4 0.6 0.3 1.2 0.5 0.6 0.2 1.2 0.3 0.7 0.2 1.3 0.3 0.6 0.1 1.2 0.2c3.4 0.5 7 0.2 10.6 0.1q5.4-0.2 11.1-0.3c7.5-0.2 15.4-0.3 23.3-0.4l5.6-0.1-0.2 0.2c0.4-5.5 0.7-11 1.1-16.2l0.2 0.2-46-9.5-0.2-0.1v-0.1c-0.4-14.2-0.7-25.8-0.9-33.9-0.1-2-0.1-3.8-0.2-5.4q-0.2-2.3-0.5-3.9-0.3-1.6-0.5-2.4-0.1-0.4-0.2-0.6 0 0 0-0.1 0 0 0 0 0 0 0-0.1 0 0 0 0z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6625",
    className: "s5",
    d: "m120.9 221.8l-6.5 50 17.2 3 12.3-44.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6626",
    className: "s0",
    d: "m66.4 154.5c0 0 63.1-4.3 76.1-2.1 7.9 1.3 14.8 14 10.4 21.6-2 3.7-5.2 14.9-5.2 14.9l-33.9-7.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3939"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6627",
    className: "s5",
    d: "m113.8 188.9l-13.6 21.5 16 10.7 17.5-27.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6628",
    className: "s0",
    d: "m22.3 150.6c0 0-6.3 29.9 4.1 42.1 10.5 12.1 25.9 12.1 41.8 9.8 15.9-2.3 53.6-3.2 53.6-3.2 0 0-1.6 10.7-2.9 22.8-1.2 12.1-1.5 19.7-1.5 19.7l23.7 2c0 0 13.1-41.2 15.2-49.4 2-8.2 1.3-19.1-5.7-23.2-5.9-3.5-52.7-16.8-75.1-18.8l-2.5-2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6629",
    className: "s1",
    d: "m133.4 189.4c0 0.1-0.9 0.2-2.3 0.7q-0.3 0.2-0.6 0.3-0.3 0.1-0.6 0.3-0.3 0.1-0.6 0.3-0.3 0.1-0.6 0.3-0.3 0.2-0.6 0.4-0.4 0.2-0.7 0.5-0.3 0.2-0.6 0.5-0.3 0.2-0.6 0.5-0.3 0.3-0.6 0.6-0.3 0.3-0.6 0.6-0.2 0.3-0.5 0.6-0.2 0.3-0.5 0.6-0.2 0.3-0.3 0.6-0.2 0.3-0.4 0.6-0.2 0.2-0.3 0.5-0.2 0.3-0.3 0.6c-0.7 1.4-0.9 2.4-1 2.3q0 0 0-0.1 0.1-0.1 0.1-0.2 0-0.1 0-0.2 0-0.1 0-0.1 0.1-0.3 0.2-0.5 0-0.2 0.1-0.4 0.1-0.2 0.1-0.5 0.1-0.2 0.2-0.4 0.1-0.3 0.3-0.6 0.1-0.3 0.3-0.6 0.1-0.3 0.3-0.6 0.2-0.3 0.4-0.6 0.2-0.4 0.5-0.7 0.2-0.3 0.5-0.6 0.3-0.4 0.6-0.7 0.3-0.3 0.6-0.5 0.3-0.3 0.6-0.6 0.3-0.3 0.6-0.5 0.4-0.2 0.7-0.5 0.4-0.2 0.7-0.4 0.3-0.2 0.6-0.3 0.3-0.2 0.6-0.3 0.3-0.1 0.7-0.3 0.3-0.1 0.6-0.2 0.2 0 0.4-0.1 0.2-0.1 0.5-0.1 0.2-0.1 0.4-0.1 0.2 0 0.5-0.1 0 0 0.1 0 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.2 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3943"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6630",
    className: "s1",
    d: "m130.6 164.5q0.1-0.4 0.2-0.7 0.1-0.3 0.3-0.6 0.1-0.4 0.3-0.7 0.2-0.3 0.4-0.5 0.2-0.3 0.4-0.6 0.2-0.3 0.4-0.6 0.3-0.3 0.5-0.5 0.3-0.2 0.6-0.4-0.4 0.6-0.7 1.2-0.4 0.5-0.8 1.1-0.4 0.6-0.8 1.2-0.4 0.5-0.8 1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6631",
    className: "s1",
    d: "m157.3 182.9q-0.1 0-0.1 0 0-0.1 0-0.1 0 0 0-0.1 0 0 0 0l-0.2-0.7c-0.1-0.6-0.3-1.5-0.7-2.6q-0.1-0.6-0.3-1.1-0.2-0.5-0.4-0.9-0.2-0.5-0.5-1-0.2-0.5-0.5-1-0.3-0.6-0.7-1.2-0.4-0.5-0.9-1-0.5-0.5-1-0.9-0.6-0.5-1.2-0.8-1.6-0.8-3.3-1.4-1.7-0.7-3.4-1.4-1.7-0.6-3.4-1.1-1.7-0.6-3.5-1.1c-5.2-1.6-11-3.3-17.1-5-12.1-3.3-23.3-5.7-31.4-7.1-4.1-0.7-7.4-1.2-9.7-1.5l-2.6-0.4-0.7-0.1q0 0-0.1 0 0 0 0 0-0.1 0-0.1 0 0 0 0 0 0 0 0 0 0 0 0.1 0 0 0 0 0 0.1 0 0.1 0h0.7l2.6 0.3c2.3 0.3 5.6 0.7 9.7 1.4q4 0.7 8 1.4 3.9 0.8 7.9 1.7 3.9 0.8 7.8 1.8 4 1 7.8 2.1c6.1 1.6 11.9 3.4 17.1 5q1.8 0.5 3.5 1.1 1.7 0.5 3.4 1.2 1.7 0.6 3.4 1.3 1.7 0.7 3.4 1.5 0.6 0.3 1.2 0.8 0.5 0.4 1 1 0.5 0.5 0.9 1.1 0.4 0.6 0.8 1.2 0.2 0.5 0.4 1 0.3 0.5 0.5 1 0.2 0.5 0.4 1 0.1 0.5 0.3 1c0.3 1.1 0.5 2.1 0.6 2.7q0.1 0.4 0.1 0.7 0 0 0 0 0.1 0.1 0.1 0.1 0 0 0 0.1 0 0 0 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6632",
    className: "s7",
    d: "m132.9 273.5l0.6-2.2q-2.6-0.2-5.2-0.9-2.6-0.7-5-1.8-2.4-1-4.7-2.5-2.2-1.5-4.1-3.2l-5.9 13 39 17.8c1.5-3.8-14.7-20.2-14.7-20.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6633",
    className: "s8",
    d: "m108.6 275.9l1.5-3.2 36.9 18.3c0 0 1.3 1.6 0.6 2.7z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6634",
    className: "s0",
    d: "m132.4 273.2c-0.1 0.2-1.1-0.1-2.3 0-1.2 0.2-2.1 0.8-2.2 0.6-0.2-0.1 0.6-1.1 2.1-1.3 1.5-0.2 2.5 0.6 2.4 0.7z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6635",
    className: "s8",
    d: "m117.3 271.8q-0.1 0.2-0.3 0.4-0.2 0.1-0.4 0.2-0.2 0.1-0.4 0.1-0.2-0.1-0.4-0.2-0.2 0-0.4-0.2-0.1-0.2-0.2-0.4-0.1-0.2-0.1-0.4 0-0.2 0.1-0.5 0.1-0.2 0.3-0.3 0.2-0.2 0.4-0.2 0.2-0.1 0.4-0.1 0.2 0 0.4 0.1 0.2 0.1 0.4 0.3 0.1 0.2 0.2 0.4 0.1 0.2 0.1 0.4-0.1 0.2-0.1 0.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    className: "s0",
    d: "m132.2 272.9q-0.1 0-0.2 0-0.2 0-0.3 0-0.1 0-0.2 0-0.1-0.1-0.2-0.1-0.3-0.1-0.6-0.2-0.3-0.1-0.6-0.3-0.3-0.1-0.5-0.3-0.3-0.2-0.5-0.4-0.1-0.1-0.1-0.2-0.1-0.1-0.2-0.1 0-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.3-0.1-0.1-0.1-0.2 0-0.1 0-0.2 0-0.2 0-0.3 0-0.2 0.1-0.3 0.1-0.2 0.2-0.3 0.1-0.1 0.3-0.1 0.1-0.1 0.3-0.1 0.1 0 0.3 0 0.1 0 0.3 0 0.1 0.1 0.3 0.1 0.5 0.3 0.9 0.7 0.5 0.4 0.8 1 0.3 0.5 0.5 1.1 0.2 0.5 0.2 1.1h-0.6q0-0.2 0.1-0.3 0-0.1 0.1-0.2 0-0.1 0.1-0.2 0-0.1 0.1-0.2 0.3-0.6 0.7-1.1 0.5-0.4 1.1-0.8 0.5-0.3 1.1-0.4 0.7-0.2 1.3-0.2 0.1 0 0.2 0 0.1 0 0.1 0 0.1 0 0.2 0.1 0.1 0 0.2 0 0 0.1 0.1 0.1 0.1 0.1 0.1 0.2 0.1 0.1 0.1 0.1 0.1 0.1 0.1 0.2 0 0.2 0 0.3 0 0.2 0 0.3-0.1 0.2-0.1 0.3-0.1 0.2-0.2 0.3-0.1 0.2-0.3 0.4-0.1 0.1-0.3 0.3-0.2 0.2-0.4 0.3-0.2 0.1-0.5 0.2-0.3 0.1-0.6 0.2-0.3 0.1-0.7 0.2-0.3 0-0.7 0-0.3 0.1-0.6 0-0.2 0-0.3 0-0.1 0-0.2 0-0.2 0-0.3 0-0.1 0-0.2-0.1 0.1 0 0.2 0 0.1 0 0.3-0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.4 0 0.7 0 0.3-0.1 0.6-0.2 0.3 0 0.6-0.1 0.4-0.1 0.6-0.3 0.2-0.1 0.4-0.2 0.2-0.1 0.4-0.2 0.1-0.2 0.3-0.3 0.1-0.2 0.2-0.4 0.1-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0-0.1 0-0.2 0-0.1 0-0.2c-0.1-0.2-0.2-0.3-0.6-0.3q-0.6 0.1-1.1 0.2-0.6 0.2-1 0.4-0.5 0.3-0.9 0.7-0.4 0.5-0.7 0.9-0.1 0.1-0.1 0.2 0 0.1-0.1 0.2 0 0.1-0.1 0.2 0 0.1 0 0.2-0.1 0.1-0.2 0.2-0.1 0.1-0.2 0-0.1 0-0.1-0.1-0.1 0-0.1-0.2 0-0.5-0.2-1-0.1-0.5-0.4-0.9-0.2-0.5-0.6-0.9-0.4-0.3-0.9-0.6c-0.5-0.3-1.1 0-1.1 0.4q0.1 0.2 0.1 0.4 0.1 0.2 0.2 0.4 0.1 0.1 0.2 0.3 0.1 0.2 0.2 0.3 0.2 0.2 0.4 0.4 0.3 0.2 0.5 0.4 0.3 0.1 0.5 0.2 0.3 0.2 0.6 0.3 0.1 0 0.2 0 0.1 0.1 0.2 0.1 0.1 0.1 0.2 0.1 0.1 0.1 0.2 0.1z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    className: "s0",
    d: "m135.4 276q-0.3 0-0.6 0-0.4 0-0.7 0-0.3 0.1-0.6 0.1-0.4 0-0.7 0.1-0.3 0.1-0.6 0.2-0.3 0.1-0.6 0.3-0.3 0.1-0.6 0.2-0.3 0.2-0.5 0.4 0.1-0.3 0.4-0.6 0.2-0.2 0.5-0.4 0.3-0.2 0.6-0.4 0.4-0.1 0.7-0.2 0.3-0.1 0.7-0.1 0.3-0.1 0.7 0 0.3 0 0.7 0.1 0.3 0.1 0.6 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    className: "s0",
    d: "m137.6 278.5c0 0.2-1.1 0.1-2.3 0.5-1.2 0.4-2.1 1-2.2 0.9q0.2-0.2 0.4-0.5 0.3-0.2 0.5-0.3 0.3-0.2 0.6-0.3 0.3-0.1 0.6-0.2 0.3-0.1 0.6-0.2 0.3-0.1 0.6-0.1 0.3 0 0.6 0.1 0.3 0 0.6 0.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6639",
    className: "s7",
    d: "m119.3 218.7l0.9-2.1q-2.6-0.7-5-1.8-2.4-1.1-4.6-2.6-2.2-1.4-4.2-3.3-1.9-1.8-3.6-3.9l-7.8 11.8 35.4 24.3c2.1-3.5-11.1-22.4-11.1-22.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6640",
    className: "s8",
    d: "m95 216.8l1.9-2.9 33.4 24.5c0 0 1.1 1.8 0.1 2.7z"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6641",
    className: "s0",
    d: "m118.8 218.3c-0.1 0.2-1-0.3-2.2-0.3-1.3-0.1-2.2 0.3-2.3 0.2-0.2-0.2 0.8-1 2.3-1 1.5 0.1 2.4 1 2.2 1.1z"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6642",
    className: "s8",
    d: "m104.1 214.3q-0.1 0.2-0.3 0.3-0.2 0.1-0.4 0.2-0.2 0-0.5 0-0.2-0.1-0.3-0.2-0.2-0.1-0.4-0.3-0.1-0.2-0.1-0.4 0-0.3 0-0.5 0-0.2 0.2-0.4 0.1-0.2 0.3-0.3 0.2-0.1 0.4-0.1 0.2-0.1 0.4 0 0.3 0 0.4 0.2 0.2 0.1 0.3 0.3 0.2 0.2 0.2 0.4 0 0.2 0 0.4-0.1 0.2-0.2 0.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6643",
    className: "s0",
    d: "m118.6 218q-0.1 0-0.2 0-0.1-0.1-0.2-0.1-0.1 0-0.2-0.1-0.1 0-0.2-0.1-0.3-0.1-0.6-0.3-0.2-0.1-0.5-0.3-0.2-0.2-0.5-0.5-0.2-0.2-0.4-0.5 0 0-0.1-0.1 0-0.1-0.1-0.2 0-0.1-0.1-0.2 0-0.1 0-0.2-0.1-0.1-0.1-0.3-0.1-0.1-0.1-0.2 0-0.1 0-0.2 0-0.2 0-0.3 0-0.1 0.1-0.3 0-0.1 0.1-0.2 0.1-0.2 0.3-0.2 0.1-0.1 0.2-0.2 0.2 0 0.3 0 0.2 0 0.4 0 0.1 0.1 0.2 0.1 0.2 0.1 0.3 0.2 0.5 0.4 0.9 0.9 0.3 0.4 0.6 1 0.2 0.6 0.3 1.2 0 0.6-0.1 1.2l-0.5-0.2q0-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0.1-0.1 0.2-0.2 0-0.1 0.1-0.2 0.4-0.5 0.9-0.9 0.5-0.4 1.2-0.6 0.6-0.2 1.2-0.3 0.6 0 1.3 0.1 0.1 0 0.1 0 0.1 0 0.2 0.1 0.1 0 0.2 0 0 0.1 0.1 0.1 0.1 0.1 0.1 0.2 0.1 0 0.1 0.1 0.1 0.1 0.1 0.2 0 0.1 0 0.2 0 0.1 0 0.3 0 0.1-0.1 0.3-0.1 0.1-0.1 0.2-0.1 0.2-0.2 0.3-0.2 0.2-0.4 0.3-0.2 0.2-0.4 0.3-0.2 0.1-0.4 0.2-0.3 0.1-0.5 0.1-0.3 0.1-0.7 0.1-0.3 0.1-0.7 0.1-0.3 0-0.6-0.1-0.4 0-0.7-0.1-0.1 0-0.3-0.1-0.1 0-0.2 0-0.1 0-0.2-0.1-0.1 0-0.3-0.1 0.2 0 0.3 0 0.1 0 0.2 0 0.2 0 0.3 0 0.1 0 0.2 0 0.3 0.1 0.7 0.1 0.3 0 0.6 0 0.3 0 0.6 0 0.4-0.1 0.7-0.2 0.2 0 0.4-0.1 0.2-0.1 0.4-0.2 0.1-0.1 0.3-0.3 0.2-0.1 0.3-0.3 0.1 0 0.1-0.1 0.1-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0-0.1 0-0.2c0-0.2-0.2-0.3-0.5-0.4q-0.6-0.1-1.1 0-0.6 0-1.1 0.2-0.6 0.2-1 0.6-0.5 0.3-0.8 0.7-0.1 0.1-0.2 0.2 0 0.1-0.1 0.2 0 0.1-0.1 0.2 0 0.1-0.1 0.2 0 0-0.1 0.1 0 0-0.1 0 0 0-0.1 0 0 0-0.1 0 0 0-0.1-0.1 0 0 0 0 0-0.1 0-0.1-0.1-0.1 0-0.1 0-0.5 0-1.1-0.1-0.5-0.3-1-0.2-0.5-0.5-0.9-0.3-0.4-0.7-0.8c-0.5-0.3-1.1-0.2-1.1 0.3q0 0.2 0 0.4 0 0.1 0.1 0.3 0 0.2 0.1 0.4 0.1 0.2 0.2 0.3 0.1 0.3 0.3 0.5 0.2 0.2 0.4 0.4 0.3 0.2 0.5 0.4 0.2 0.2 0.5 0.3c0.5 0.3 0.8 0.5 0.7 0.5z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6644",
    className: "s0",
    d: "m121.3 221.6q-0.3-0.1-0.6-0.1-0.3-0.1-0.7-0.1-0.3 0-0.6-0.1-0.3 0-0.7 0-0.3 0.1-0.6 0.1-0.3 0.1-0.6 0.2-0.3 0.1-0.6 0.2-0.4 0.1-0.7 0.2 0.3-0.3 0.6-0.5 0.2-0.2 0.6-0.3 0.3-0.2 0.6-0.3 0.4 0 0.7 0 0.4-0.1 0.7-0.1 0.4 0 0.7 0.1 0.3 0.1 0.6 0.3 0.4 0.2 0.6 0.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6645",
    className: "s0",
    d: "m123 224.5c0 0.1-1-0.1-2.3 0.1-1.2 0.1-2.2 0.6-2.3 0.4q0.3-0.2 0.5-0.3 0.3-0.2 0.6-0.3 0.2-0.2 0.5-0.2 0.4-0.1 0.7-0.1 0.3-0.1 0.6-0.1 0.3 0 0.6 0.1 0.3 0 0.6 0.1 0.3 0.1 0.5 0.3z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChar2);
export default __webpack_public_path__ + "static/media/char2.be7a452cd83bc8904c3b69a87c40a967.svg";
export { ForwardRef as ReactComponent };